import { ViewModel,View, ObservableArray } from "binder"
import { distinct } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import  { PhoneInputView } from "./phoneInput-view"

export class PhoneInputViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.phones = ObservableArray.create<IPhone>();
        this.writtenText = "";
    }
    GetDefaultView(): View <ViewModel> {
        return new PhoneInputView();
    }
    public getTypeId(): string {
        return "VM-D3B44289-8F4F-4E80-8A51-743B042057E7"
    }

    public set writtenText(v: string) { this._writtenText = v; } public get writtenText(): string { return this._writtenText;} private _writtenText: string;
    public set phones(v: ObservableArray<IPhone>) { this._phones = v; } public get phones(): ObservableArray<IPhone> { return this._phones;} private _phones: ObservableArray<IPhone>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    getPhones():Phone[]{
        return this.phones.filter(x=>x instanceof Phone).map(x=><Phone>x);
    }
    getCellPhones():CellPhone[]{
        return this.phones.filter(x=>x instanceof CellPhone).map(x=><CellPhone>x);
    }
    isEmpty(): boolean {
        return (this.phones.length == 0) ? true : false;
    }
    hasRepetitivePhone() : boolean{
        var phoneStrings = distinct(this.phones.map(x=>x.getAsString()));
        if(phoneStrings.length==this.phones.length)
            return false;
        return true;
    }
    async confirm(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PhoneServices/ParsePhones',{
                Phones:[this.writtenText]
            });
            this.phones.push(...result.Phones.map(x=>{
                let p = new Phone(this);
                p.countryCode = x.CountryCode;
                p.cityCode = x.CityCode;
                p.number = x.Number;
                return p;
            }));
            this.phones.push(...result.CellPhones.map(x=>{
                let p = new CellPhone(this);
                p.countryCode = x.CountryCode;
                p.number = x.Number;
                return p;
            }));
            this.writtenText = "";
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    removePhone(phone: IPhone) {
        this.phones.remove(phone);
    }

}

export interface IPhone{
    remove();
    getAsString():string;
}
export class Phone extends ViewModel implements IPhone{
    public getTypeId(): string {return 'phone';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PhoneInputViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    public set countryCode(v: string) { this._countryCode = v; } public get countryCode(): string { return this._countryCode;} private _countryCode: string;
    public set cityCode(v: string) { this._cityCode = v; } public get cityCode(): string { return this._cityCode;} private _cityCode: string;
    public set number(v: string) { this._number = v; } public get number(): string { return this._number;} private _number: string;
    private typedParent:PhoneInputViewModel;

    remove() {
        this.typedParent.removePhone(this);
    }
    getAsString():string{
        return `${this.countryCode}-${this.cityCode}-${this.number}`;
    }
}
export class CellPhone extends ViewModel implements IPhone{
    public getTypeId(): string {return 'cellphone';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PhoneInputViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent:PhoneInputViewModel;
    public set countryCode(v: string) { this._countryCode = v; } public get countryCode(): string { return this._countryCode;} private _countryCode: string;
    public set number(v: string) { this._number = v; } public get number(): string { return this._number;} private _number: string;
    
    remove() {
        this.typedParent.removePhone(this);
    }
    getAsString():string{
        return `${this.countryCode}-${this.number}`;
    }
}
